import { useEffect, useState } from 'react';
import { useScrollMeter, useScrollTo } from '../lib/motion';
import './Nav.css';

export const SECTIONS = [
  { id: 'work',         label: 'Work',    idx: '01' },
  { id: 'architecture', label: 'Systems', idx: '02' },
  { id: 'console',      label: 'Console', idx: '03' },
  { id: 'studio',       label: 'Studio',  idx: '04' },
  { id: 'method',       label: 'Method',  idx: '05' },
  { id: 'stack',        label: 'Stack',   idx: '06' },
  { id: 'record',       label: 'Record',  idx: '07' },
];

export default function Nav({ ready }) {
  const { y, progress, dir } = useScrollMeter();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('');
  const scrollTo = useScrollTo();

  /* Active section tracking */
  useEffect(() => {
    const hit = SECTIONS.filter(({ id }) => {
      const el = document.getElementById(id);
      if (!el) return false;
      return el.getBoundingClientRect().top <= 180;
    });
    setActive(hit.length ? hit[hit.length - 1].id : '');
  }, [y]);

  /* Lock scroll behind the overlay */
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  /* Escape closes */
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollTo(id), open ? 520 : 0);
  };

  const condensed = y > 60;
  const hidden = dir === 'down' && y > 640 && !open;

  return (
    <>
      {/* Scroll progress hairline */}
      <div className="nav-progress" aria-hidden="true">
        <span style={{ transform: `scaleX(${progress})` }} />
      </div>

      <header
        className={[
          'nav',
          ready ? 'nav--ready' : '',
          condensed ? 'nav--condensed' : '',
          hidden ? 'nav--hidden' : '',
        ].join(' ')}
      >
        <nav className="nav-pill" aria-label="Primary">
          <button className="nav-mark" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Back to top">
            <span className="nav-mark-glyph">
              <img src={`${process.env.PUBLIC_URL}/test1.png`} alt="" aria-hidden="true" />
            </span>
            <span className="nav-mark-meta">
              <b>Poanta Rareș</b>
              <i>Full-Stack Engineer</i>
            </span>
          </button>

          <ul className="nav-links">
            {SECTIONS.map(({ id, label, idx }) => (
              <li key={id}>
                <button
                  className={`nav-link ${active === id ? 'is-active' : ''}`}
                  onClick={() => go(id)}
                  aria-current={active === id ? 'true' : undefined}
                >
                  <span className="nav-link-idx">{idx}</span>
                  <span className="nav-link-label">{label}</span>
                </button>
              </li>
            ))}
          </ul>

          <div className="nav-end">
            <button className="btn btn--volt btn--sm nav-cta" onClick={() => go('contact')}>
              Start a project
              <svg className="btn-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
              </svg>
            </button>

            <button
              className={`nav-burger ${open ? 'is-open' : ''}`}
              onClick={() => setOpen((o) => !o)}
              aria-label={open ? 'Close menu' : 'Open menu'}
              aria-expanded={open}
            >
              <span /><span />
            </button>
          </div>
        </nav>
      </header>

      {/* Full-screen menu */}
      <div className={`menu ${open ? 'menu--open' : ''}`} aria-hidden={!open}>
        <div className="menu-slats" aria-hidden="true">
          {[0, 1, 2, 3, 4].map((i) => (
            <span key={i} style={{ transitionDelay: `${open ? i * 48 : (4 - i) * 34}ms` }} />
          ))}
        </div>

        <div className="menu-inner">
          <span className="mono menu-eyebrow">Navigation</span>
          <ul className="menu-list">
            {SECTIONS.map(({ id, label, idx }, i) => (
              <li key={id} style={{ transitionDelay: `${open ? 240 + i * 55 : 0}ms` }}>
                <button onClick={() => go(id)} className="menu-link">
                  <span className="menu-idx">{idx}</span>
                  <span className="menu-label">{label}</span>
                  <svg className="menu-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="19" x2="19" y2="5" /><polyline points="7 5 19 5 19 17" />
                  </svg>
                </button>
              </li>
            ))}
          </ul>

          <div className="menu-foot" style={{ transitionDelay: `${open ? 240 + SECTIONS.length * 55 : 0}ms` }}>
            <a href="mailto:rarespoanta10@gmail.com" className="btn btn--volt btn--lg" onClick={() => setOpen(false)}>
              rarespoanta10@gmail.com
            </a>
            <div className="menu-socials">
              <a href="https://github.com/rarespoanta27" target="_blank" rel="noopener noreferrer">GitHub</a>
              <a href="https://www.linkedin.com/in/rares-poanta-b3970b309" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
